import { z } from 'zod'

export const SignupDtoSchema = z.object({
  firstname: z.string(),
  lastname: z.string(),
  email: z.string(),
  phone: z.string(),
  password: z.string(),
  repeat_password: z.string(),
  utm: z.object({
    campaign: z.string().nullable(),
    source: z.string().nullable(),
    medium: z.string().nullable(),
  }),
})

export const SignupSchema = z
  .object({
    firstname: z.string(),
    lastname: z.string(),
    email: z.string().email(),
    phone: z.string(),
    password: z.string().min(6),
    repeatPassword: z.string().min(6),
    utm: z
      .object({
        campaign: z.string().nullable().optional(),
        source: z.string().nullable().optional(),
        medium: z.string().nullable().optional(),
      })
      .optional(),
  })
  .refine(
    (values) => {
      return values.password === values.repeatPassword
    },
    {
      message: 'Пароли должны совпадать',
      path: ['repeatPassword'],
    },
  )
